import * as Stimulus from "@hotwired/stimulus"

/**
 * generic navigation helper
 **/
export class NavigationController extends Stimulus.Controller {
    back() {
        history.back();
    }
}
